import { Icon, IconSize, IconVariants } from "@next-platform/client-common-spicy-ui";
import { useLanguage } from "@next-platform/client-common-core";
import { Dropdown, DropdownItem, DropdownMenu, DropdownSection, DropdownTrigger } from "@nextui-org/react";
import type { Key } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import TextStyles from "@/components/common/TextStyles";
import { SpicyButton } from "@/components/customComponents";
import { ROUTES } from "@/constants";
import { getMonthLabel } from "@/utils";

import { FilterByMonthProps } from "./types";

export default function FilterByMonth(props: FilterByMonthProps) {
  const { options = [], selectedDate, setSelectedDate } = props;
  const { currentLanguage } = useLanguage();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();

  useEffect(() => {
    if (options.length) {
      const querySelectedDate = queryParams.get("date");
      const isDateExist = querySelectedDate && options.includes(querySelectedDate);
      if (isDateExist) {
        setSelectedDate(new Set([querySelectedDate]));
      } else {
        setSelectedDate(new Set([options[0]]));
        navigate(ROUTES.leaderboards, { replace: true });
      }
    }
  }, [options]);

  const handleDropdownAction = (key: Key) => {
    const value = String(key);
    setSelectedDate(new Set([value]));

    if (value === options[0]) {
      navigate(ROUTES.leaderboards, { replace: true });
    } else {
      queryParams.set("date", value);
      navigate({ pathname: ROUTES.leaderboards, search: queryParams.toString() }, { replace: true });
    }
  };

  return (
    <div>
      <Dropdown classNames={TextStyles.dropdown.base}>
        <DropdownTrigger className="z-0">
          <SpicyButton variant="secondary" color="primary_light">
            {getMonthLabel([...selectedDate][0], currentLanguage)}
            <Icon icon={IconVariants.CHEVRON_DOWN} size={IconSize.XSMALL} className="ml-0.5" />
          </SpicyButton>
        </DropdownTrigger>
        <DropdownMenu selectionMode="single" selectedKeys={selectedDate} onAction={handleDropdownAction} classNames={TextStyles.dropdown.menu}>
          {options.map((option, idx) => (
            <DropdownSection key={idx} classNames={TextStyles.dropdown.section}>
              <DropdownItem classNames={TextStyles.dropdown.item} key={option} value={option}>
                {getMonthLabel(option, currentLanguage)}
              </DropdownItem>
            </DropdownSection>
          ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}
